import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import EventsAwardsE50PageContent from "@e50/EventsAwardsE50PageContent";
import {
  EventsAwardsLandingPageContextData,
  EventsAwardsPageContext,
} from "@events-awards/utils/types";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

export default function EventsAwardsE50Page(): React.ReactElement {
  const { context } =
    useRouteContext<
      TRouteWithRedirect<
        EventsAwardsPageContext<EventsAwardsLandingPageContextData>,
        string
      >
    >();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind !== "section") {
          // Error or kind is not "art"
          return <CustomError statusCode={context.statusCode} />;
        }

        // StatusCode is 200 and kind is "art"
        return <EventsAwardsE50PageContent {...data} />;
      }}
    </Await>
  );
}
